/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Bengio_TitleInputs */

const en_home_quotes_bengio_title = /** @type {(inputs: Home_Quotes_Bengio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Turing Award winner`)
};

/**
* | output |
* | --- |
* | "AI Turing Award winner" |
*
* @param {Home_Quotes_Bengio_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_bengio_title = /** @type {((inputs?: Home_Quotes_Bengio_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Bengio_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_bengio_title(inputs)
});